import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useEffect } from 'react';

import { isProduction, useAppSelector } from 'shared/lib';
import { isFieldRequired } from 'shared/lib/isFieldRequired';
import { logFormData } from 'shared/lib/logFormData';
import { sendEventFormFieldError } from 'shared/lib/sendGAEvents';

import { commonValidationSchema, selectAllFormFields } from 'entities/creditForm';

export const useSendFieldErrorAnalyticsEvent = <Values extends Record<string, unknown>>(
  step: number,
  fieldLabels: Record<keyof Values, string>,
) => {
  const isProd = isProduction();
  const { formState, getValues } = useFormContext<Values>();
  const actualFormData = useAppSelector(selectAllFormFields);
  const { errors } = formState;

  useEffect(() => {
    // использовать только на dev/stage
    if (!isProd && errors && Object.keys(errors).length > 0) {
      logFormData('Step submit errors', errors, (key, value) => ({
        field: key,
        value: getValues(key as never),
        message: value?.message,
        errorType: value?.type,
      }));
    }
  }, [errors, isProd, getValues]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const error = Object.keys(errors).map((key, value) => ({ key, value }))[0];
      sendEventFormFieldError(
        step,
        fieldLabels[error.key],
        isFieldRequired(commonValidationSchema, error.key, actualFormData),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);
};
